const stripExtension = (name) => name.replace(/\.[^/.]+$/, "");

const getExtension = (name) => {
  const lastDotIndex = name.lastIndexOf(".");

  return lastDotIndex !== -1
    ? name.substring(lastDotIndex + 1).toLowerCase()
    : "";
};

const isImage = (url) =>
  /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url?.split(/[?#]/)[0]);

export { stripExtension, getExtension, isImage };
